export namespace UsersConstants {

  export const ROLES = {
    ROLE_OSMOS_USER: 'ROLE_OSMOS_USER',
    ROLE_CLIENT: 'ROLE_CLIENT',
    ROLE_INSTALLER: 'ROLE_INSTALLER',
    ROLE_ADMIN: 'ROLE_ADMIN',
    ROLE_BE: 'ROLE_BE',
    ROLE_PRODUCTION: 'ROLE_PRODUCTION',
    ROLE_MATHS: 'ROLE_MATHS',
    ROLE_SAFE_ALL_LEVELS: 'ROLE_SAFE_ALL_LEVELS',
    ROLE_COMMERCIAL: 'ROLE_COMMERCIAL',
    ROLE_CONTACT: 'ROLE_CONTACT',
    ROLE_ALARM_VALIDATOR: 'ROLE_ALARM_VALIDATOR'
  };

}
